import { Injectable } from '@angular/core';
import { fromLegacyPromise, getAngularJSService } from '../ng-upgrade.utils';
import { DashboardParams, DashboardResponseMap, DashboardType } from '@core/models';

interface LegacyHttpResponse<T> {
  data: T;
}

interface LegacyDashboardFactory {
  getGraphDataV2<T extends DashboardType>(
    params: DashboardParams<T>
  ): Promise<LegacyHttpResponse<DashboardResponseMap[T] | null | undefined>>;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private dashboardFactory: LegacyDashboardFactory | null = null;

  private get factory(): LegacyDashboardFactory {
    if (this.dashboardFactory) {
      return this.dashboardFactory;
    }
    const svc = getAngularJSService<LegacyDashboardFactory>('dashboardFactory');
    if (!svc) {
      throw new Error(
        'dashboardFactory (AngularJS) is unavailable. AngularJS may not have been bootstrapped yet.'
      );
    }
    this.dashboardFactory = svc;
    return this.dashboardFactory;
  }

  async getGraphData<T extends DashboardType>(
    params: DashboardParams<T>
  ): Promise<DashboardResponseMap[T] | null> {
    // WRAPPER — reescrever com HttpClient quando dashboardFactory for removida
    const response = await fromLegacyPromise(this.factory.getGraphDataV2<T>(params));
    return response.data ?? null;
  }
}
